import script from "./luPidContest.vue?vue&type=script&setup=true&lang=ts"
export * from "./luPidContest.vue?vue&type=script&setup=true&lang=ts"

import "./luPidContest.vue?vue&type=style&index=0&id=0fb48bc1&scoped=true&lang=css"

import exportComponent from "/home/aschmuck/wk/eSklepios/medsw/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0fb48bc1"]])

export default __exports__